import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=1bae1c5c&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"
import style0 from "./navbar.vue?vue&type=style&index=0&id=1bae1c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae1c5c",
  null
  
)

export default component.exports